'use client';
import { AuthProvider } from '@/context/auth';
import { CartProvider } from '@/context/auth/cart-provider';
import { UserDataProvider } from '@/context/auth/user-data-provider';
import { MswProvider } from '@/context/msw-provider';
import { routing } from '@/i18n/routing';
import { apolloClient } from '@/lib/apollo-client';
import { ApolloProvider } from '@apollo/client';
import type { Locale } from 'next-intl';
import { NextIntlClientProvider, hasLocale } from 'next-intl';
import { notFound } from 'next/navigation';
import type React from 'react';

export default function Providers({
    children,
    locale,
    messages,
}: {
    children: React.ReactNode;
    locale: Locale;
    messages: unknown;
}) {
    if (!hasLocale(routing.locales, locale)) {
        notFound();
    }

    return (
        <MswProvider>
            <ApolloProvider client={apolloClient}>
                <NextIntlClientProvider locale={locale} messages={messages as Record<string, unknown>}>
                    <AuthProvider>
                        <UserDataProvider>
                            <CartProvider>{children}</CartProvider>
                        </UserDataProvider>
                    </AuthProvider>
                </NextIntlClientProvider>
            </ApolloProvider>
        </MswProvider>
    );
}
